import React, { useState, useMemo } from "react";
import { v4 as uuidv4 } from "uuid";

import { useApp } from "context/appContext";
import { typeTicket } from "forms/reservation";

const ReservationContext = React.createContext();

export function ReservationProvider(props) {
  const [events, setEvents] = useState([]);
  const [assistants, setAssistants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [event, setEvent] = useState(null);
  const [ticket, setTicket] = useState(typeTicket[0].value);
  const [showTable, setShowTable] = useState(false);
  const [currentAssistant, setCurrentAssistant] = useState(null);
  const [ccs, setCcs] = useState([]);
  const { showNotification } = useApp();
  const [iglekids, setIglekids] = useState(false);
  // eslint-disable-next-line
  const [_, setShowInfoAssistants] = useState(false);
  const [idError, setIdError] = useState("");

  // Manage events
  const handleSelectEvent = (id) => {
    let eventSelected = events.find((eve) => {
      return eve.id === id;
    });
    setEvent(eventSelected);
  };

  // Manage assistants
  const handleAddAssistant = (assistant) => {
    // const cc = ccs.find((c) => c === assistant.numberId);
    // if (!cc) {
    //   setIdError(assistant.numberId);
    //   setShowNoIdInfo(true);
    //   return false;
    // }
    if (!assistant.covid) {
      showNotification(
        "Debido a que presentas síntomas recomendamos que te quedes en casa y disfrutes de nuestro servicio online.",
        "error"
      );
      return;
    }
    const id = uuidv4();
    let clone = JSON.parse(JSON.stringify(assistants));
    assistant.id = id;
    clone.push(assistant);
    setAssistants(clone);
    setCurrentAssistant(null);
    setShowTable(true);
  };

  const handleEditAssistant = (assistant) => {
    // const cc = ccs.find((c) => c === assistant.numberId);
    // if (!cc) {
    //   setIdError(assistant.numberId);
    //   setShowNoIdInfo(true);
    //   return false;
    // }
    if (!assistant.covid) {
      showNotification(
        "Debido a que presentas síntomas recomendamos que te quedes en casa y disfrutes de nuestro servicio online.",
        "error"
      );
      return;
    }
    let newAssistants = assistants.filter(
      (ass) => ass.id !== currentAssistant.id
    );
    console.log("currentAssistant: ", currentAssistant);
    console.log("newAssistants: ", newAssistants);
    assistant.id = currentAssistant.id;
    newAssistants.push(assistant);
    setAssistants(newAssistants);
    setCurrentAssistant(null);
    setShowTable(true);
  };

  const handleRemoveAssistant = (cc) => {
    const newAssistants = assistants.filter(
      ({ numberId, typeId }) => cc !== `${typeId} ${numberId}`
    );
    setAssistants(newAssistants);
  };

  const handleGoIglekids = () => {
    if (assistants && assistants.length) {
      setShowInfoAssistants(true);
    } else {
      setIglekids(!iglekids);
    }
  };

  const handleGoIglekidsAfterModal = () => {
    setAssistants([]);
    setShowInfoAssistants(false);
    setShowTable(false);
    setIglekids(!iglekids);
  };

  // eslint-disable-next-line
  const value = useMemo(() => {
    return {
      events,
      event,
      assistants,
      loading,
      showTable,
      currentAssistant,
      iglekids,
      idError,
      ticket,
      setTicket,
      setIdError,
      handleGoIglekids,
      setShowTable,
      handleSelectEvent,
      handleAddAssistant,
      handleEditAssistant,
      handleRemoveAssistant,
      setCurrentAssistant,
      setLoading,
      setShowInfoAssistants,
      handleGoIglekidsAfterModal,
      ccs,
      setEvents,
      setEvent,
      setCcs,
    };
  });

  return <ReservationContext.Provider value={value} {...props} />;
}

export function useReservation() {
  const context = React.useContext(ReservationContext);
  if (!context) {
    throw new Error(
      "useReservation debe estar dentro del proveedor ReservationContext"
    );
  }
  return context;
}
